import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutAddresssComponentDef } from '@df/checkout/checkout-address.component.def';
import { injectTimeoutService } from '@df/ng/timeout.service';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { AddressFieldsetComponent } from '../ui/form/address-fieldset/address-fieldset.component';
import { CheckboxComponent } from '../ui/form/checkbox';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { AddressStatusChangeEvent } from '../ui/form/local-address-fieldset-def.component';
import { RadioComponent } from '../ui/form/radio';
import { CheckoutFormComponent } from './checkout-form.component';
import { CheckoutStepComponent } from './checkout-step.component';

@Component({
    selector: 'checkout-address',
    templateUrl: './checkout-address.html',
    standalone: true,
    imports: [
        AddressFieldsetComponent,
        CheckboxComponent,
        CommonModule,
        FormsModule,
        InputWrapBodyDirective,
        InputWrapComponent,
        RadioComponent,
        RadioGroupDirective,
        SizeClassDirective,
        TranslatePipe
    ]
})
export class CheckoutAddressComponent extends CheckoutAddresssComponentDef implements OnInit, AfterViewInit {
    public override readonly checkoutFormComponent = inject(CheckoutFormComponent);
    public override readonly checkoutStepComponent = inject(CheckoutStepComponent);
    protected readonly disposableTimeoutService = injectTimeoutService();

    override ngOnInit(): void {
        super.ngOnInit();
        this.changePaymentAddress();
    }

    ngAfterViewInit(): void {
        if (this.data && this.data.customer_address_id) {
            this.disposableTimeoutService.setTimeout(() => this.checkoutFormComponent.goToNextStep(), 100);
        }

        this.onInputsBlur();
    }

    onInputsBlur(): void {
        if (this.isBilling) {
            this.checkoutFormComponent.saveBillingAddress();
        } else {
            this.checkoutFormComponent.saveShippingAddress();
        }
    }

    /**
     * Go to next step if address is valid
     */
    onAddressStatusChange(event: number | AddressStatusChangeEvent): void {
        this.changePaymentAddress();

        if ((event instanceof AddressStatusChangeEvent && event.valid && !event.isNew) || (typeof event === 'number' && event > 0)) {
            this.disposableTimeoutService.setTimeout(() => this.checkoutFormComponent.goToNextStep(), 100);
        }
    }

    changeBillingToShipping(): void {
        this.checkoutFormComponent.isBillingToShipping = false;
    }

    protected changePaymentAddress() {
        if (!this.checkoutFormComponent.isBillingToShipping && this.checkoutFormComponent.data?.address?.billing?.customer_address_id > 0) {
            this.checkoutFormComponent.changePaymentAddress = false;
        } else {
            this.checkoutFormComponent.changePaymentAddress = true;
        }

        this.checkoutFormComponent.detectChanges();
    }
}
